export default function (state, value) {
    state.value = value ? value : null;
}